import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.machine.render');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-component-machine-render',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.machine.render/view.scss */
/* src/app/component.machine.render/view.scss: no such file or directory */`],
})
export class ComponentMachineRenderComponent implements OnInit {

  @Input() data: any;
  @Input() sortable: boolean = true;

  opts = { sortable: true };

  ngOnInit() {
    this.opts.sortable = this.sortable !== false;
  }

    public src(file?: string): string {
        if (!file) return '';
        return `/assets/images/png/${file}`;
    }
}

export default ComponentMachineRenderComponent;